var render, staticRenderFns
import script from "./CrudEdit.vue?vue&type=script&lang=js&"
export * from "./CrudEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/apps/oil/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62fe7a98')) {
      api.createRecord('62fe7a98', component.options)
    } else {
      api.reload('62fe7a98', component.options)
    }
    
  }
}
component.options.__file = "src/components/CrudEdit.vue"
export default component.exports